/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';
import { Separators } from 'components';

export const Container = styled.hr`
  border: none;
  position: relative;
  overflow: visible;
  ${({ type, label, labelBackground }) => {
    if (type === Separators.separatorTypes.small) {
      return css`
        border-top: 1px solid ${Palette.PrimaryGray._200};
      `;
    }
    if (type === Separators.separatorTypes.medium) {
      return css`
        border-top: 2px solid ${Palette.PrimaryGray._100};
      `;
    }
    if (type === Separators.separatorTypes.big) {
      return css`
        border-top: 4px solid ${Palette.PrimaryGray._100};
      `;
    }
    if (type === Separators.separatorTypes.dashed) {
      return css`
        border-top: 1px dashed ${Palette.PrimaryGray._200};
      `;
    }
    if (type === Separators.separatorTypes.dotted) {
      return css`
        border-top: 1px dotted ${Palette.PrimaryGray._200};
      `;
    }
    if (type === Separators.separatorTypes.with_label) {
      return css`
        border-top: 1px solid ${Palette.PrimaryGray._200};
        ::after {
          content: '${label}';
          color: ${Palette.PrimaryGray._500};
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 16px;
          position: absolute;
          left: 50%;
          bottom: 0;
          transform: translateX(-50%) translateY(50%);
          padding: 0 8px;
          background: ${labelBackground};
        }
      `;
    }
  }};
`;
